import React, { useRef, useState } from 'react'

import { resource } from 'api'
import { TextEditorHTMLUI } from './TextEditorHTMLUI'

const TextEditorHTML = ({ id, company, channel, value, options, placeholder, className, onChange, onPreviewMsg }) => {
  const quillRef = useRef(null)
  const [isOpenEmojis, setIsOpenEmojis] = useState(false)
  const [errors, setErrors] = useState({})

  const handleOnChange = (value) => {
    const data = {
      value: value.replace(/(<([^>]+)>)/ig, ''),
      valueHtml: value
    }
    onChange(data)
  }

  const onToggleEmojis = () => setIsOpenEmojis(!isOpenEmojis)

  const onSelectEmoji = (emoji) => {
    updateEditor({ value: emoji.native })
    if (isOpenEmojis) onToggleEmojis()
  }

  const updateEditor = ({ value }) => {
    const editor = quillRef.current.getEditor()
    const unprivilegedEditor = quillRef.current.makeUnprivilegedEditor(editor)
    const range = unprivilegedEditor.getSelection()

    const position = range ? range.index : 0
    editor.insertText(position, value)
  }

  const onUploadFiles = async ({ file }) => {
    try {
      const formData = new FormData()
      const dataBody = {
        companyType: company.type,
        companyToken: company.hash,
        typeUpload: 'userFile',
      }

      formData.append('data', JSON.stringify(dataBody))
      formData.append('files', file)

      const { data } = await resource.uploadFiles(formData)

      return data
    } catch (error) {
      setErrors(prevState => ({
        ...prevState,
        modules: {
          ...prevState.modules,
          handlers: {
            ...prevState.modules.handlers,
            image: error.message
          }
        }
      }))
    }
  }

  return (
    <TextEditorHTMLUI
      quillRef={quillRef}
      id={id}
      channel={channel}
      value={value}
      options={options}
      placeholder={placeholder}
      className={className}
      handleOnChange={handleOnChange}
      uploadFiles={onUploadFiles}
      onPreviewMsg={onPreviewMsg}
      isOpenEmojis={isOpenEmojis}
      onToggleEmojis={onToggleEmojis}
      onSelectEmoji={onSelectEmoji}
      errors={errors}
    />
  )
}

export { TextEditorHTML }
